// Social Wall
var sowl = document.querySelector('.sowl');

if (sowl) {
    var svg = '<svg role="img" aria-label="Facebook" width="20px" height="20px" viewBox="0 0 44 44" class="ff-label-icon" xmlns="http://www.w3.org/2000/svg"><path d="M28.1456 23.4793L28.8623 19.1915H24.3813V16.4091C24.3813 15.236 25.0072 14.0926 27.0141 14.0926H29.0513V10.442C29.0513 10.442 27.2026 10.1523 25.4351 10.1523C21.7449 10.1523 19.3328 12.206 19.3328 15.9236V19.1915H15.2308V23.4793H19.3328V33.8447H24.3813V23.4793H28.1456Z"/></svg>';

    setTimeout(() => {
        var items = document.querySelectorAll('.ff-item');
        var labels = document.querySelectorAll('.ff-icon-inner');
    
        items.forEach(function(item) {
            var feedValue = item.getAttribute('data-feed');
            var name = item.querySelector('.ff-label-text');
    
            switch (feedValue) {
                case "dl06967":
                    name.textContent = "Ville de Biscarrosse";
                break;
                
                case "nm70212":
                    name.textContent = "Médiathèque";
                break;
                
                case "wt33526":
                    name.textContent = "L'Arcanson";
                break;
                            
                case "wm61303":
                    name.textContent = "Bisca Grands Lacs";
                break;
                
                case "cx73222":
                    name.textContent = "Musée de l'hydraviation";
                break;
                
                default:
                    name.textContent = "Biscarrosse";
            }
        });
    
        labels.forEach(function(label) {
            label.insertAdjacentHTML('afterbegin', svg);
        });
    
    }, "2000")
}